export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
        badge: {
          color: 'primary',
          
        }
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Data Master',
        route: '/data-master',
        icon: 'cil-puzzle',
        items: [
          {
            name: 'Informasi Umum',
            to: '/data-master/informasi-umum'
          },          
          {
            name: 'Divisi',
            to: '/data-master/divisi'
          },
          {
            name: 'Level',
            to: '/data-master/level'
          },
          {
            name: 'Data Test Center',
            to: '/data-master/data-test-center'
          },
          {
            name: 'Cabang',
            to: '/data-master/cabang'
          },
          {
            name: 'Kupon',
            to: '/data-master/kupon'
          },
          {
            name: 'Master Lokasi ',
            to: '/data-master/master-lokasi'
          },          
          {
            name: 'Master Karir ',
            to: '/data-master/karir'
          },          
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        _class: 'usermanajemen',
        _ref: 'usermanajemen',
        id: 'usermanajemen',
        slot: 'user-slot',
        name: 'User Manajemen',
        route: '/user-manajement',
        icon: 'cil-puzzle',
        items: [
          {
            name: 'Petugas IAPI',
            to: '/user-manajemen/petugas-iapi'
          },
          {
            name: 'Petugas TC',
            to: '/user-manajemen/petugas-tc'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Sertifikasi',
        route: '/sertifikasi',
        icon: 'cil-puzzle',
        items: [
          {
            name: 'Master Mata Uji',
            to: '/sertifikasi/master-mata-uji'
          },
          {
            name: 'Master Sertifikasi',
            to: '/sertifikasi/master-sertifikasi'
          },
          {
            name: 'Master RPL',
            to: '/sertifikasi/master-rpl-workshop'
          },
          {
            name: 'Jadwal TC',
            to: '/sertifikasi/jadwal-tc'
          },
          {
            name: 'Data Peserta',
            to: '/sertifikasi/data-peserta'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: ' Keanggotaan',
        route: '/keanggotaan',
        icon: 'cil-puzzle',
        items: [
          {
            name: 'Kategori Anggota',
            to: '/keanggotaan/kategori-anggota'
          },
          {
            name: 'Data Anggota',
            to: '/keanggotaan/data-anggota'
          },
          {
            name: 'KAP',
            to: '/keanggotaan/kap'
          },
          {
            name: 'Pelaporan SKP',
            to: '/keanggotaan/pelaporan-skp'
          },
          {
            name: 'Pengajuan Rekomendasi',
            to: '/keanggotaan/pengajuan-rekomendasi'
          },
          {
            name: 'Asean CPA',
            to: '/keanggotaan/asean-cpa'
          },
          {
            name: 'Generate Annual Invoice',
            to: '/keanggotaan/invoice'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Pelatihan',
        route: '/pelatihan',
        icon: 'cil-puzzle',
        items: [
          {
            name: 'Kuesioner',
            to: '/pelatihan/kusioner'
          },
          {
            name: 'Workshop',
            to: '/pelatihan/workshop/penyelenggara'
          },
          {
            name: 'Data Peserta',
            to: '/pelatihan/data-peserta'
          },
          {
            name: 'Data Pengajuan SKP',
            to: '/pelatihan/data-pengajuan-skp'
          },
          {
            name: 'Signature',
            to: '/pelatihan/signature'
          },
          {
            name: 'E-Certificate',
            to: '/pelatihan/e-certificate'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Finance',
        route: '/finance',
        icon: 'cil-puzzle',
        items: [
          {
            name: 'Sales Order',
            to: '/finance/sales-order'
          },
          {
            name: 'Payment',
            to: '/finance/payment'
          },
          {
            name: 'E-Kwitansi',
            to: '/finance/e-kwitansi'
          },
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Broadcast',
        route: '/boradcast',
        icon: 'cil-puzzle',
        items: [
          {
            name: 'Broadcast email',
            to: '/broadcast-email'
          },
          {
            name: 'Broadcast Pesan Aplikasi',
            to: '/broadcast-pesan-aplikasi'
          },          
          {
            name: 'Broadcast Whatsapp',
            to: '/broadcast-whatsapp'
          },          
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Log Activity',
        to: '/log-activity',
        icon: 'cil-puzzle',
        badge: {
          color: 'primary',
          
        }
      }      
     
    ]
  }
]